module.exports = __webpack_public_path__ + "img/yan2.7e036040.png";